// src/pages/OrderViewer/components/OrderDetailStep.styles.ts
import styled from "styled-components";

export const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 14px 10px;
`;

export const TopBarTitle = styled.h2`
  font-weight: 900;
  font-size: 16.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
  margin: 0;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const OrderHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 0 14px;
`;

export const OrderTitle = styled.div`
  font-weight: 900;
  font-size: 17px;
  color: ${(p) => p.theme.tokens.colors.ink};
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const Meta = styled.div`
  font-size: 12.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  padding: 2px 14px 0;
`;

export const ProductRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid ${(p) => p.theme.tokens.colors.softBg};

  &:last-child {
    border-bottom: none;
  }
`;

export const ProductName = styled.div`
  font-size: 13.5px;
  font-weight: 700;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const ProductMeta = styled.div`
  font-size: 12px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 2px;
`;

export const ProductNote = styled.div`
  font-size: 12px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 2px;
`;

export const ProductTotal = styled.div`
  font-size: 13.5px;
  font-weight: 800;
  color: ${(p) => p.theme.tokens.colors.ink};
  white-space: nowrap;
`;

export const TotalLabel = styled.span`
  font-size: 15px;
  font-weight: 900;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const TotalValue = styled.span`
  font-size: 17px;
  font-weight: 900;
  color: ${(p) => p.theme.tokens.colors.teal};
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
`;
